var files = require.context('../views/inCComps');
export default(Vue) => {
    files.keys().map(files).forEach(item => {
        Vue.component(item.name,item);
    })
}



// WEBPACK FOOTER //
// ./src/utils/common.js